import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import Header from 'components/dialogs/DialogHeader';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';

function SuspendMemberDialog({ open, onClose, onSuspend, ...props }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} {...props}>
      <Header data-testid="suspend-dialog-title">
        {t('organization.organization-members-edit-suspend-box.title-box-member-suspend')}
      </Header>
      <DialogContent>
        <Typography variant="body2" color="secondary" marginBottom="24px">
          {t('organization.organization-members-edit-suspend-box.box-text-organization-members-exclude')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={onClose} data-testid="cancel-button">
          {t('organization.organization-members-edit-suspend-box.button-cancel')}
        </Button>
        <Button fullWidth color="gradient" onClick={onSuspend} data-testid="confirm-button">
          {t('organization.organization-members-edit-suspend-box.button-suspend')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SuspendMemberDialog;
